module.exports = __webpack_public_path__ + "static/media/GT04_ST_Room-Types.08ae3e91.csv";